import React from "react";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { processSteps } from "../mock";
import { House, PenTool, FileCheck2, HardHat, Hammer, BadgeCheck } from "lucide-react";

const iconMap = { House, PenTool, FileCheck2, HardHat, Hammer, BadgeCheck };

export default function Process() {
  return (
    <section id="process" className="max-w-6xl mx-auto px-6 py-16">
      <div className="mb-6">
        <Badge className="bg-[hsl(22,100%,50%)]/10 text-[hsl(22,100%,40%)]">Our process</Badge>
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight mt-3">From first visit to final handover</h2>
        <p className="text-muted-foreground mt-2 max-w-prose">A clear, accountable sequence with weekly updates and site checks.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {processSteps.map((s, i) => {
          const Icon = iconMap[s.icon] || House;
          return (
            <Card key={i} className="bg-white/70 backdrop-blur-md transition-transform duration-300 hover:-translate-y-1">
              <CardContent className="p-6">
                <div className="flex items-center gap-3">
                  <div className="h-9 w-9 rounded-md bg-[hsl(22,100%,50%)] text-white flex items-center justify-center"><Icon className="h-5 w-5" /></div>
                  <div className="font-semibold">{s.title}</div>
                </div>
                <p className="text-sm text-muted-foreground mt-3">{s.desc}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </section>
  );
}